import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AddGroupMemberRoleFulfilledAction } from '../../domains/groupAddRemoveMemberRole/addGroupMemberRole.types';
import { RemoveGroupMemberRoleFulfilledAction } from '../../domains/groupAddRemoveMemberRole/removeGroupMemberRole.types';
import {
  GroupRoleMembersFulfilledAction,
  GroupRoleMembersPendingAction,
  GroupRoleMembersRejectedAction,
} from '../../domains/groupRoleMembers/actions.types';
import { getGroupRoleMemberKey, groupMemberRoleFilterMap } from '../../domains/groupRoleMembers/selectors';
import { GroupMembersEdge } from '../types';

import { GroupsRoleMembers } from './types';

export const initialState: GroupsRoleMembers = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type GroupRoleMembersActions =
  | GroupRoleMembersPendingAction
  | GroupRoleMembersFulfilledAction
  | GroupRoleMembersRejectedAction
  | AddGroupMemberRoleFulfilledAction
  | RemoveGroupMemberRoleFulfilledAction;

const addRoleMember = (
  state: GroupsRoleMembers,
  { groupId, userId, role }: AddGroupMemberRoleFulfilledAction['payload']
) => {
  const groupRoleMemberKey = getGroupRoleMemberKey(groupId, groupMemberRoleFilterMap[role]);
  const groupRoleMembers = state.fulfilled.byId[groupRoleMemberKey];

  return update(state, groupRoleMemberKey, {
    ...groupRoleMembers,
    roleMembers: [
      ...groupRoleMembers.roleMembers,
      {
        nodeId: userId,
        isAdmin: false,
      },
    ],
  });
};

const removeRoleMember = (
  state: GroupsRoleMembers,
  { groupId, userId, role }: RemoveGroupMemberRoleFulfilledAction['payload']
) => {
  const groupRoleMemberKey = getGroupRoleMemberKey(groupId, groupMemberRoleFilterMap[role]);
  const groupRoleMembers = state.fulfilled.byId[groupRoleMemberKey];

  return groupRoleMembers
    ? update(state, groupRoleMemberKey, {
        ...groupRoleMembers,
        roleMembers: groupRoleMembers.roleMembers.filter((member: GroupMembersEdge) => member.nodeId !== userId),
      })
    : state;
};

const reducer: Reducer<GroupsRoleMembers, GroupRoleMembersActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_ROLE_MEMBERS.LOAD_PENDING':
      return moveToPending(state, [getGroupRoleMemberKey(action.payload.id, action.payload.roleFilter)]);
    case 'GROUP_ROLE_MEMBERS.LOAD_FULFILLED':
      return moveToFulfilled(state, {
        [getGroupRoleMemberKey(action.payload.id, action.payload.roleFilter)]:
          action.payload.entities.groupRoleMembers[action.payload.id],
      });
    case 'GROUP_ROLE_MEMBERS.LOAD_REJECTED':
      return moveToRejected(
        state,
        [getGroupRoleMemberKey(action.payload.id, action.payload.roleFilter)],
        action.payload.error
      );
    case 'GROUP.ADD_MEMBER_ROLE_FULFILLED':
      return addRoleMember(state, action.payload);
    case 'GROUP.REMOVE_MEMBER_ROLE_FULFILLED':
      return removeRoleMember(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
